export default "__VITE_ASSET____Dnza8P__"